import { Box, Typography, Alert, AlertTitle } from '@mui/material'
import { useState, useEffect } from 'react'
import TopBar from '../../components/TopBar'
import Module from '../../components/Module'
import { BaseService } from '../../services/BaseService'
import { useQuery } from 'react-query'
import { getDecodeUser } from '../../utils/getDecodeUser'
import LoaderHomePage from '../../components/Loader/LoaderHomePage'
import useTranslate from '../../utils/i18n'
import { getLocalStorageData } from '../../utils/storage/storage'
// import PermissionHandler from '../../components/permissionHandler/permissionHandler'
import PermissionModal from '../../components/permissionHandler/PermissionModal'
import { getLocalPermission } from '../../utils/permission'

async function fetchModules(param) {
  // const params = {
  //   ...param,
  // }
  const service = new BaseService('/m_modul_2')
  const data = await service.getModulesV2(param)
  return data
}

const HomePage = () => {
  // const [enabled, setEnabled] = useState(true)
  const { t } = useTranslate()
  const user = getDecodeUser()
  // console.log({ user })
  const userLang = getLocalStorageData('userLang')

  // const setParams = []
  // setParams.push(user?.position)

  const [openPermission, setOpenPermission] = useState(false)

  useEffect(() => {
    const check = async () => {
      const local = getLocalPermission()

      // ⚡ langsung dari cache dulu
      if (!local.camera || !local.location) {
        setOpenPermission(true)
      }

      // 🔍 validasi real
      let cam = false
      let loc = false

      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true })
        stream.getTracks().forEach((t) => t.stop())
        cam = true
      } catch {
        cam = false
      }

      await new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
          () => {
            loc = true
            resolve()
          },
          () => {
            loc = false
            resolve()
          },
        )
      })

      if (!cam || !loc) {
        setOpenPermission(true)
      } else {
        setOpenPermission(false)
      }
    }

    check()
  }, [])

  const [isNotChrome, setIsNotChrome] = useState(false)

  useEffect(() => {
    const ua = navigator.userAgent
    // Deteksi apakah BUKAN Chrome (menghindari Edge dan Opera yang engine-nya sama)

    const isAndroidChrome = ua.includes('Chrome') && !ua.includes('Edg') && !ua.includes('OPR')

    const isIOSChrome = ua.includes('CriOS')

    const isChrome = isAndroidChrome || isIOSChrome

    if (!isChrome) {
      setIsNotChrome(true)
    }
  }, [])

  const params = {
    user: JSON.stringify(user?.position),
    flag_eng: userLang === 'en' ? 1 : 0,
    id_modul: user?.soal,
    id_user: Number(user?.id),
  }

  const { isLoading, data } = useQuery(
    ['modules', user?.id],
    async () => {
      // setEnabled(false)
      return await fetchModules(params)
    },
    {
      // enabled: enabled,
    },
  )

  if (!user) {
    window.location.reload()
    return <LoaderHomePage />
  }

  // alert('halo')

  // return 'test'
  // eslint-disable-next-line react-hooks/exhaustive-deps

  return (
    <Box pt={2} height={'100%'}>
      {/* <PermissionHandler /> */}
      <PermissionModal open={openPermission} onClose={() => setOpenPermission(false)} />
      <TopBar />

      <Box mt={3}>
        {isNotChrome && (
          <Box mb={2}>
            <Alert severity="warning" variant="outlined" onClose={() => setIsNotChrome(false)}>
              <AlertTitle>Rekomendasi Peramban</AlertTitle>
              Beberapa fitur mungkin tidak berjalan dengan baik untuk browser selain{' '}
              <strong>Google Chrome</strong>.
            </Alert>
          </Box>
        )}

        <Box
          position={'sticky'}
          mx={'-16px'}
          top={0}
          zIndex={1}
          sx={{
            padding: '14px 16px',
            backgroundColor: ({ palette }) => palette.background.default,
          }}
        >
          <Typography variant="h4">{t('moduleAvailable')}</Typography>
        </Box>

        {isLoading ? (
          <LoaderHomePage />
        ) : (
          <>
            {data?.status === 'gagal' ? (
              <Box
                p={3}
                height="200px"
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  borderRadius: '10px',
                  backgroundColor: '#ff8a003b',
                }}
              >
                Module Belum tersedia
              </Box>
            ) : (
              <Module data={data?.data?.length > 0 && data.data} />
            )}
          </>
        )}
      </Box>
    </Box>
  )
}

export default HomePage
